import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import AgenteIaImobiliaria from "@/pages/AgenteIaImobiliaria";

export const Route = createFileRoute("/agente-ia-imobiliaria")({
  head: () => buildHead({
    title: "Agente de IA para Imobiliária: lead respondido em segundos",
    description: "Agente de IA que qualifica leads, envia imóveis e agenda visitas no WhatsApp e no Instagram 24h. Pare de perder cliente para quem respondeu antes. CRM incluso.",
    path: "/agente-ia-imobiliaria",
  }),
  component: AgenteIaImobiliaria,
});
